import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

interface TitleProps {
  /** `page` para el encabezado de la vista; `card` para el título de una tarjeta. */
  size?: 'page' | 'card';
  /** Atenúa el título a gris para estados deshabilitados. */
  muted?: boolean;
}

const SIZES = {
  page: { fontSize: '30px', fontWeight: 600, letterSpacing: '-0.3px' },
  card: { fontSize: '17px', fontWeight: 600, letterSpacing: 'normal' },
} as const;

/**
 * Primitivo de título. Renderiza un `<h2>` por defecto; usa `as="h1"` cuando
 * encabeza la página para mantener la jerarquía semántica correcta.
 */
const Title = styled.h2<TitleProps>(({ size = 'card', muted = false }) => ({
  margin: 0,
  fontFamily: t.font,
  color: muted ? t.color.disabledTitle : t.color.title,
  ...SIZES[size],
}));

export default Title;
